import * as React from "react";
import styles from "@styles/pages/shipping-policy/index.module.scss";
import {strapi} from "@api/Strapi";

// @ts-ignore
function ShippingPolicy({shippingPolicy}) {

    /**
     * The page contain about the product shipping policy
     * The text are managed via 3 different styles and one for list.
     */
    return (
        <>
            <div className={styles.banner}>
                <h1 className={'title-text'}>shipping policy</h1>
            </div>
            <div className={styles.container} dangerouslySetInnerHTML={{__html: shippingPolicy}}/>
        </>
    )
}

export async function getServerSideProps(context: any) {

    let seoDetails = {
        title: `Shipping Policy | SIDR®`,
        description: '',
        keyword: '',
        url: context.resolvedUrl,
    };

    try {
        const response = await strapi.getShippingPolicy();
        if (response.status == 200 && response.data) {
            seoDetails = {
                title: response.data.data.attributes.SEO_Title ? response.data.data.attributes.SEO_Title : `Shipping Policy | SIDR®`,
                description: response.data.data.attributes.SEO_Description ? response.data.data.attributes.SEO_Description : ``,
                keyword: response.data.data.attributes.SEO_Keyword ? response.data.data.attributes.SEO_Keyword : ``,
                url: context.resolvedUrl,
            };
            return {props: {shippingPolicy: response.data.data.attributes.Shipping_Policy, seoDetails}}
        }
        return {props: {seoDetails}}
    } catch (e) {
        console.log(e)
        return {props: {seoDetails}}
    }
}

export default ShippingPolicy;
